// extracted by mini-css-extract-plugin
module.exports = {"Results":"ResultsList_Results__C0W3V","ResultsPending":"ResultsList_ResultsPending__BW2Sr","List":"ResultsList_List__cab7_"};